{
  "pt": {
    "window": {
      "app": "Aplicação",
      "customersDashboard": "Painel de controlo",
      "customersDecisionDocuments": "Decisão",
      "customersDecisionProposals": "Propostas de decisão",
      "customersDecisionTickets": "Decisão",
      "customersDecisionTicketsShow": "Decisão",
      "customersDecisions": "Decisões",
      "customersDocuments": "Documentos",
      "customersDocumentsAll": "Síntese do documento",
      "customersDocumentsFolder": "Categoria do documento",
      "customersDocumentsFolders": "Categorias de documentos",
      "customersInspirationLists": "Inspirações",
      "customersInspirationListsShow": "Inspirações",
      "customersInstallmentTerms": "Prestações",
      "customersIssues": "Cuidados posteriores",
      "customersIssuesList": "Cuidados posteriores",
      "customersProjectInformation": "Informações sobre o projeto",
      "customersQuestionLists": "FAQs",
      "customersQuestionListsShow": "FAQs",
      "customersRoot": "Painel de controlo",
      "customersRootSettingsProfile": "Definições",
      "customersSettingsProfile": "Definições",
      "customersTickets": "Conversas",
      "customersTicketsNew": "Nova conversa",
      "customersTicketsShow": "Conversação",
      "employeesClientContacts": "Contactos",
      "employeesClientContactsNew": "Novo contacto",
      "employeesClientContactsNewCustomer": "Novo cliente",
      "employeesClientContactsNewEmployee": "Novo membro da equipa",
      "employeesClientContactsNewPartner": "Novo parceiro",
      "employeesClientContactsType": "Contactos",
      "employeesClientDashboard": "Painel de controlo",
      "employeesClientProjects": "Projectos",
      "employeesClientProjectsNew": "Novo projeto",
      "employeesClientTickets": "Conversas",
      "employeesClientTicketsNew": "Nova conversa",
      "employeesClientTicketsShow": "Conversação",
      "employeesMarketplace": "Mercado",
      "employeesProjectActivity": "Atividade",
      "employeesProjectAnnouncements": "Feed de notícias",
      "employeesProjectDecisionActivity": "Atividade",
      "employeesProjectDecisionDocuments": "Decisão",
      "employeesProjectDecisionProposalTemplate": "Modelos de propostas",
      "employeesProjectDecisionProposals": "Propostas",
      "employeesProjectDecisionReminders": "Lembretes",
      "employeesProjectDecisionTickets": "Conversas",
      "employeesProjectDecisionTicketsShow": "Conversação",
      "employeesProjectDecisionTypeNew": "Nova decisão",
      "employeesProjectDecisionTypes": "Decisões",
      "employeesProjectDecisions": "Decisões",
      "employeesProjectDecisionsEdit": "Decisões",
      "employeesProjectDecisionsNew": "Nova decisão",
      "employeesProjectDocuments": "Documentos",
      "employeesProjectInformationPageActivity": "Atividade",
      "employeesProjectInformationPageAftercare": "Cuidados posteriores",
      "employeesProjectInformationPageDecisions": "Decisões",
      "employeesProjectInformationPageDocuments": "Documentos",
      "employeesProjectInformationPageInformation": "Informações",
      "employeesProjectInformationPageInstallments": "Prestações",
      "employeesProjectInformationPageLevels": "Níveis",
      "employeesProjectInformationPageMilestones": "Marcos históricos",
      "employeesProjectInformationPageSpaces": "Espaços",
      "employeesProjectInformationPageSurveys": "Inquéritos",
      "employeesProjectInformationPageTasks": "Tarefas",
      "employeesProjectInformationPageTickets": "Conversas",
      "employeesProjectInstallmentGroup": "Finanças",
      "employeesProjectInstallmentGroupNew": "Novo prazo da prestação",
      "employeesProjectInstallmentGroups": "Finanças",
      "employeesProjectInstallmentGroupsList": "Finanças",
      "employeesProjectInstallmentGroupsMatrix": "Prestações",
      "employeesProjectInstallmentNew": "Novas prestações",
      "employeesProjectIssueListTypeIssues": "Lista de obstáculos - Todos os obstáculos",
      "employeesProjectIssueListTypeNew": "Nova lista de corte",
      "employeesProjectIssueListTypeUnits": "Lista de reclamações - Visão geral da unidade",
      "employeesProjectIssueListTypes": "Listas de reclamações",
      "employeesProjectIssueListUnitDocuments": "Problemas na unidade - Documentos",
      "employeesProjectIssueListUnitIssues": "Problemas na unidade",
      "employeesProjectIssueListUnitTickets": "Unidade Snags - Bilhetes",
      "employeesProjectIssueListUnitTicketsShow": "Conversas",
      "employeesProjectIssueListsNew": "Novos obstáculos",
      "employeesProjectMilestones": "Marcos históricos",
      "employeesProjectQuestionLists": "FAQs",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Vendas",
      "employeesProjectSurveySummary": "Inquérito",
      "employeesProjectSurveyTypes": "Inquéritos",
      "employeesProjectSurveys": "Inquérito",
      "employeesProjectTickets": "Conversas",
      "employeesProjectTicketsEmailConversations": "Emails",
      "employeesProjectTicketsEmailConversationsShow": "Correio eletrónico",
      "employeesProjectTicketsNew": "Nova conversa",
      "employeesProjectTicketsShow": "Conversas",
      "employeesProjectTodoLists": "Tarefas",
      "employeesSettingsClientAftercare": "Pós-Venda",
      "employeesSettingsClientInformation": "Administrador",
      "employeesSettingsClientIntegrations": "Integrações",
      "employeesSettingsProfile": "Perfil",
      "level": "Nível",
      "mployeesProjectInstallmentGroups": "Finanças",
      "partnersClientProjects": "Projectos",
      "partnersProjectDecisionDocuments": "Documentos",
      "partnersProjectDecisionProposals": "Propostas",
      "partnersProjectDecisionTickets": "Conversas",
      "partnersProjectDecisionTicketsShow": "Conversação",
      "partnersProjectDecisionTypesItems": "Decisões",
      "partnersProjectDecisions": "Decisões",
      "partnersProjectDocuments": "Documentos",
      "partnersProjectDocumentsUnit": "Documentos",
      "partnersProjectIssueListTypeIssues": "Lista de obstáculos - Todos os obstáculos",
      "partnersProjectIssueListTypeUnits": "Lista de reclamações - Visão geral da unidade",
      "partnersProjectIssueListTypes": "Listas de reclamações",
      "partnersProjectIssueListUnitDocuments": "Unidade Snags - Documentos",
      "partnersProjectIssueListUnitIssues": "Problemas na unidade",
      "partnersProjectIssueListUnitTickets": "Unidade Snags - Bilhetes",
      "partnersSettingsProfile": "Perfil",
      "root": "Aplicação"
    }
  }
}
